// extracted by mini-css-extract-plugin
export default {"fileSizeError":"FileUpload_fileSizeError__ymgVc"};